/* eslint-disable no-empty */
import { call, put, takeLatest } from 'redux-saga/effects';
import actionTypes from 'store/actionTypes';
import actions from 'store/actions/index';
import xeniaApi from 'api/index';
import {
  ChecklistFolderSortOrderFolderTypeInterface,
  ChecklistFolderSortOrderInterface,
  ChecklistItemSortOrderInterface,
  ChecklistItemSortOrderItemTypeInterface,
  ChecklistItemUpdateModel,
  ChecklistRemovePostInterface,
  ListBodyParam,
  PostApiCallbackRequestType,
  RemovePromiseApiRequestType,
} from 'models/index.m';
import { Action } from 'models/actionModel';

/*******************
  @Purpose : Used for get checklist folder list
  @Parameter :
  @Author : INIC
  ******************/
function* getChecklistFolderListDataApiCall(
  ListpostParam: Action<ListBodyParam>,
): any {
  try {
    const checklistFolderListResponse = yield call(
      xeniaApi.checklistFolderListing,
      ListpostParam.payload,
    );
    if (checklistFolderListResponse) {
      yield put(actions.setChecklistFolderList(checklistFolderListResponse));
      yield put(actions.setChecklistFolderListIsFetching(false));
    } else {
      yield put(actions.setChecklistFolderList([]));
      yield put(actions.setChecklistFolderListIsFetching(false));
    }
  } catch (error) {
    yield put(actions.setChecklistFolderList([]));
    yield put(actions.setChecklistFolderListIsFetching(false));
  }
}

/*******************
  @Purpose : Used for add new checklist folder
  @Parameter :
  @Author : INIC
  ******************/
function* addNewChecklistFolderApiCall(
  action: Action<PostApiCallbackRequestType>,
): any {
  try {
    const addChecklistFolderResponse = yield call(
      xeniaApi.addChecklistFolder,
      action.payload.postData,
    );
    if (addChecklistFolderResponse !== null) {
      action.payload.callbackResolve(addChecklistFolderResponse);
    } else {
      action.payload.callbackResolve(null);
    }
  } catch (error) {
    action.payload.callbackResolve(null);
  }
}

/*******************
  @Purpose : Used for add new checklist
  @Parameter :
  @Author : INIC
  ******************/
function* addNewChecklistApiCall(
  action: Action<PostApiCallbackRequestType>,
): any {
  try {
    if (action.payload?.postData?.ChecklistId !== '') {
      yield put(actions.setExistChecklistItemIsAdding(true));
    } else {
      yield put(actions.setChecklistIsAdding(true));
    }
    const addChecklistResponse = yield call(
      xeniaApi.addChecklist,
      action.payload.postData,
    );
    if (addChecklistResponse !== null) {
      yield put(actions.setChecklistIsAddSuccess(true));
      yield put(actions.setExistChecklistItemsIsAddingSuccess(true));
    }
  } catch (error) {
  } finally {
    if (action.payload?.postData?.ChecklistId !== '') {
      yield put(actions.setExistChecklistItemIsAdding(false));
    } else {
      yield put(actions.setChecklistIsAdding(false));
    }
  }
}

/*******************
  @Purpose : Used for update exist checklist folder
  @Parameter :
  @Author : INIC
  ******************/
function* updateChecklistFolderApiCall(
  action: Action<PostApiCallbackRequestType>,
): any {
  try {
    const updateChecklistFolderResponse = yield call(
      xeniaApi.updateChecklistFolder,
      action.payload.postData,
      action.payload.id,
    );
    if (updateChecklistFolderResponse !== null) {
      action.payload.callbackResolve(updateChecklistFolderResponse);
    } else {
      action.payload.callbackResolve(null);
    }
  } catch (error) {
    action.payload.callbackResolve(null);
  }
}
/*******************
  @Purpose : Used for update exist checklist item
  @Parameter :
  @Author : INIC
  ******************/
function* updateChecklistItemApiCall(
  action: Action<ChecklistItemUpdateModel>,
): any {
  try {
    yield put(actions.setChecklistItemIsUpdating(true));
    const updateChecklistItemResponse = yield call(
      xeniaApi.updateChecklistItem,
      action.payload.postData,
      action.payload.id,
    );
    if (updateChecklistItemResponse !== null) {
      yield put(actions.setChecklistItemIsUpdateSuccess(true));
    }
  } catch (error) {
  } finally {
    yield put(actions.setChecklistItemIsUpdating(false));
  }
}

/*******************
  @Purpose : Used for update checklist folder order
  @Parameter :
  @Author : INIC
  ******************/
function* updateChecklistFolderSortOrderApiCall(
  action: Action<ChecklistFolderSortOrderFolderTypeInterface>,
): any {
  try {
    const postData: ChecklistFolderSortOrderInterface = {
      folderId:
        action.payload as unknown as ChecklistFolderSortOrderFolderTypeInterface[],
    };
    const updateChecklistSortOrderResponse = yield call(
      xeniaApi.updateChecklistFolderSortOrder,
      postData,
      true,
    );
    if (updateChecklistSortOrderResponse !== null) {
      return true;
    }
  } catch (error) {
  } finally {
  }
}

/*******************
  @Purpose : Used for  update checklist item  order
  @Parameter :
  @Author : INIC
  ******************/
function* updateChecklistItemSortOrderApiCall(
  action: Action<ChecklistItemSortOrderItemTypeInterface>,
): any {
  try {
    const postData: ChecklistItemSortOrderInterface = {
      checkListItemId:
        action.payload as unknown as ChecklistItemSortOrderItemTypeInterface[],
    };
    const updateChecklistSortOrderResponse = yield call(
      xeniaApi.updateChecklistFolderSortOrder,
      postData,
      false,
    );
    if (updateChecklistSortOrderResponse !== null) {
      return true;
    }
  } catch (error) {
  } finally {
  }
}

/*******************
  @Purpose : Used for update exist checklist name
  @Parameter :
  @Author : INIC
  ******************/
function* updateChecklisNameApiCall(
  action: Action<PostApiCallbackRequestType>,
): any {
  try {
    yield put(actions.setChecklistIsUpdating(true));
    const updateChecklistNameResponse = yield call(
      xeniaApi.updateChecklistName,
      action.payload.postData,
      action.payload.id,
    );
    if (updateChecklistNameResponse !== null) {
      yield put(actions.setChecklistIsUpdateSuccess(true));
    }
  } catch (error) {
  } finally {
    yield put(actions.setChecklistIsUpdating(false));
  }
}

/*******************
  @Purpose : Used for remove checklist folder
  @Parameter :
  @Author : INIC
  ******************/
function* removeChecklistFolderApiCall(
  action: Action<RemovePromiseApiRequestType>,
): any {
  try {
    const removeChecklistFolderResponse = yield call(
      xeniaApi.removeChecklistFolder,
      action.payload.id,
    );
    if (removeChecklistFolderResponse !== null) {
      action.payload.callbackResolve(removeChecklistFolderResponse);
    } else {
      action.payload.callbackResolve(null);
    }
  } catch (error) {
    action.payload.callbackResolve(null);
  }
}

/*******************
  @Purpose : Used for remove checklist
  @Parameter :
  @Author : INIC
  ******************/
function* removeChecklistApiCall(
  action: Action<ChecklistRemovePostInterface>,
): any {
  try {
    yield put(actions.setChecklistIsRemoving(true));
    const removeChecklistResponse = yield call(
      xeniaApi.removeChecklist,
      action.payload.id,
    );
    if (removeChecklistResponse !== null) {
      yield put(actions.setChecklistIsRemoveSuccess(true));
    }
  } catch (error) {
  } finally {
    yield put(actions.setChecklistIsRemoving(false));
  }
}

/*******************
  @Purpose : Used for remove checklist item
  @Parameter :
  @Author : INIC
  ******************/
function* removeChecklistItemApiCall(
  action: Action<RemovePromiseApiRequestType>,
): any {
  try {
    yield put(actions.setChecklistItemIsRemoving(true));
    const removeChecklistItemResponse = yield call(
      xeniaApi.removeChecklistItem,
      action.payload.id,
    );
    if (removeChecklistItemResponse !== null) {
      yield put(actions.setChecklistItemsIsRemovingSuccess(true));
    }
  } catch (error) {
  } finally {
    yield put(actions.setChecklistItemIsRemoving(false));
  }
}

/*******************
  @Purpose : Used for get folder wise checklist data
  @Parameter :
  @Author : INIC
  ******************/
function* foldersChecklistDataApiCall(
  action: Action<PostApiCallbackRequestType>,
): any {
  try {
    const folderChecklistResponse = yield call(
      xeniaApi.foldersChecklistApi,
      action.payload.postData,
    );
    if (folderChecklistResponse !== null) {
      action.payload.callbackResolve(folderChecklistResponse);
    } else {
      action.payload.callbackResolve(null);
    }
  } catch (error) {
    action.payload.callbackResolve(null);
  }
}

/*******************
  @Purpose : Used for get checklist items data
  @Parameter :
  @Author : INIC
  ******************/
function* ChecklistItemsDataApiCall(
  action: Action<PostApiCallbackRequestType>,
): any {
  try {
    const checklistItemsResponse = yield call(
      xeniaApi.checklistItemsApi,
      action.payload.postData,
    );
    if (checklistItemsResponse !== null) {
      action.payload.callbackResolve(checklistItemsResponse);
    } else {
      action.payload.callbackResolve(null);
    }
  } catch (error) {
    action.payload.callbackResolve(null);
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function* checklistWatcher() {
  yield takeLatest(
    actionTypes.LIST_CHECKLIST_FOLDER,
    getChecklistFolderListDataApiCall,
  );

  yield takeLatest(
    actionTypes.CREATE_CHECKLIST_FOLDER,
    addNewChecklistFolderApiCall,
  );

  yield takeLatest(
    actionTypes.REMOVE_CHECKLIST_FOLDER,
    removeChecklistFolderApiCall,
  );

  yield takeLatest(
    actionTypes.UPDATE_CHECKLIST_FOLDER,
    updateChecklistFolderApiCall,
  );

  yield takeLatest(
    actionTypes.FOLDERS_CHECKLIST_DATA,
    foldersChecklistDataApiCall,
  );

  yield takeLatest(
    actionTypes.CHECKLIST_ITEMS_LIST_DATA,
    ChecklistItemsDataApiCall,
  );

  yield takeLatest(
    actionTypes.CREATE_NEW_CHECKLIST_IN_FOLDER,
    addNewChecklistApiCall,
  );

  yield takeLatest(
    actionTypes.ADD_ITEM_IN_EXIST_CHECKLIST,
    addNewChecklistApiCall,
  );

  yield takeLatest(actionTypes.REMOVE_CHECKLIST, removeChecklistApiCall);

  yield takeLatest(
    actionTypes.UPDATE_CHECKLIST_NAME,
    updateChecklisNameApiCall,
  );

  yield takeLatest(
    actionTypes.REMOVE_CHECKLIST_ITEM,
    removeChecklistItemApiCall,
  );

  yield takeLatest(
    actionTypes.UPDATE_CHECKLIST_ITEM,
    updateChecklistItemApiCall,
  );
  yield takeLatest(
    actionTypes.UPDATE_CHECKLIST_FOLDER_SORT_ORDER,
    updateChecklistFolderSortOrderApiCall,
  );
  yield takeLatest(
    actionTypes.UPDATE_CHECKLIST_ITEM_SORT_ORDER,
    updateChecklistItemSortOrderApiCall,
  );
}
